/**
 * Maps a PurchasedCustomPrint's configuration into a configuration
 * that is expected by the Configurator.
 *
 * @param {Object} [purchasedCustomPrint] The PurchasedCustomPrint.
 * @returns {{}|{custom_print_caption, photos}}
 */
export const mapPurchasedCustomPrintToConfiguration = purchasedCustomPrint => {
  if (!purchasedCustomPrint) {
    return {};
  }

  return {
    custom_print_caption: purchasedCustomPrint.custom_print_caption,
    photos: purchasedCustomPrint.photos.records,
  };
};
